import React from 'react';
import { NotesEntityFields } from 'common/graphql/__generated__/NotesEntityFields';
import {
  NoteTravelAuthorizationCreate,
  NoteTravelAuthorizationCreateVariables,
} from 'common/graphql/__generated__/NoteTravelAuthorizationCreate';
import { NotesSectionProps } from 'common/components/NotesSection';
import { GenericNotesSection } from 'common/components/ActionMenu/Notes';

import NOTE_TRAVEL_AUTHORIZATION_CREATE from 'common/graphql/NoteTravelAuthorizationCreate.graphql';

type NotesProps = Pick<NotesSectionProps, 'listRefreshRequest'> & {
  id: string;
  data: NotesEntityFields[];
  loading?: boolean;
};

export const Notes: React.FC<NotesProps> = ({
  id,
  data,
  loading,
  listRefreshRequest,
}) => {
  return (
    <GenericNotesSection<
      any,
      NoteTravelAuthorizationCreate, // TMutationResult
      NoteTravelAuthorizationCreateVariables // TMutationVariables
    >
      entityId={id}
      data={data}
      loading={loading}
      mutationDocument={NOTE_TRAVEL_AUTHORIZATION_CREATE}
      listRefreshRequest={listRefreshRequest}
    />
  );
};
